import PropTypes from 'prop-types';
import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Input from 'components/ui/input';
import { withTranslation } from 'react-i18next';
import unitConverter from 'convert-units';
import { withLocaleContext } from 'providers/locale-settings-context';
import { getCurrencySymbol } from 'components/modules/master/formatters';

class TariffOtherPropsEditor extends React.Component {
  onChange(key, value) {
    this.props.onChange(key, value);
  }

  handleMinimumDistanceChange() {
    const { localeData } = this.props;
    return () => {
      const minimumDistance = this.refs.minimumDistanceInput.getValue();
      const formattedDistanceInMiles = unitConverter(minimumDistance)
        .from(localeData.distance_units)
        .to('mi');
      this.onChange(
        'minimum_distance',
        Number(formattedDistanceInMiles).toFixed(2),
      );
    };
  }

  handleMinimumWeightChange() {
    const { localeData } = this.props;
    return () => {
      const minimumWeight = this.refs.minimumWeightInput.getValue();
      const formattedWeightInLbs = unitConverter(minimumWeight)
        .from(localeData.weight_units)
        .to('lb');
      this.onChange('minimum_weight', Number(formattedWeightInLbs).toFixed(2));
    };
  }

  handleMinimumCostChange() {
    return () => {
      const minimumCost = this.refs.minimumCostInput.getValue();
      this.onChange('minimum_cost', minimumCost);
    };
  }

  handleMaximumCostChange() {
    return () => {
      const maximumCost = this.refs.maximumCostInput.getValue();
      this.onChange('maximum_cost', maximumCost);
    };
  }

  handleCostPerExtraMileChange() {
    return () => {
      const costPerExtraMile = this.refs.costPerExtraMileInput.getValue();
      this.onChange('cost_per_extra_mile', costPerExtraMile);
    };
  }

  handleCostPerExtraLbsChange() {
    return () => {
      const costPerExtraLb = this.refs.costPerExtraLbsInput.getValue();
      this.onChange('cost_per_extra_lb', costPerExtraLb);
    };
  }

  handleConversationRateChange() {
    return () => {
      const boxToPalletConversionRate =
        this.refs.conversationRateInput.getValue();
      this.onChange('box_to_pallet_conversion_rate', boxToPalletConversionRate);
    };
  }

  handleFSCConversion = (e) => {
    const fsc = e.target.value;
    this.onChange('fsc', fsc);
  };

  render() {
    const tariff = this.props.tariff || {};
    const { t, localeData } = this.props;
    let minimum_distance = unitConverter(tariff.minimum_distance)
      .from('mi')
      .to(localeData.distance_units);
    minimum_distance = minimum_distance
      ? minimum_distance.toFixed(2)
      : minimum_distance;
    let minimum_weight = unitConverter(tariff.minimum_weight)
      .from('lb')
      .to(localeData.weight_units);
    minimum_weight = minimum_weight
      ? minimum_weight.toFixed(2)
      : minimum_weight;

    return (
      <Grid fluid>
        <Row className="show-grid">
          <Col xs={2}>
            <Input
              type="number"
              label={t('MINIMUM_DISTANCE_WITH_UNIT', {
                distanceUnit: localeData.distance_units,
              })}
              defaultValue={minimum_distance}
              ref="minimumDistanceInput"
              onChange={this.handleMinimumDistanceChange()}
            />
            <Input
              type="number"
              label={t('MINIMUM_WEIGHT_WITH_UNIT', {
                weight_units: localeData.weight_units,
              })}
              defaultValue={minimum_weight}
              ref="minimumWeightInput"
              onChange={this.handleMinimumWeightChange()}
            />
          </Col>
          <Col xs={2}>
            <Input
              type="number"
              label={t('MINIMUM_COST_WITH_CURRENCY', {
                currency: getCurrencySymbol(DEFAULT_CURRENCY),
              })}
              defaultValue={tariff.minimum_cost}
              ref="minimumCostInput"
              onChange={this.handleMinimumCostChange()}
            />
            <Input
              type="number"
              label={t('MAXIMUM_COST_WITH_CURRENCY', {
                currency: getCurrencySymbol(DEFAULT_CURRENCY),
              })}
              defaultValue={tariff.maximum_cost}
              ref="maximumCostInput"
              onChange={this.handleMaximumCostChange()}
            />
          </Col>
          <Col xs={2}>
            <Input
              type="number"
              label={t('COST_PER_EXTRA_DISTANCE', {
                distanceUnit: localeData.distance_units,
                currency: getCurrencySymbol(DEFAULT_CURRENCY),
              })}
              defaultValue={tariff.cost_per_extra_mile}
              ref="costPerExtraMileInput"
              onChange={this.handleCostPerExtraMileChange()}
            />
            <Input
              type="number"
              label={t('COST_PER_EXTRA_WEIGHT', {
                weight_units: localeData.weight_units,
                currency: getCurrencySymbol(DEFAULT_CURRENCY),
              })}
              defaultValue={tariff.cost_per_extra_lb}
              ref="costPerExtraLbsInput"
              onChange={this.handleCostPerExtraLbsChange()}
            />
          </Col>
          <Col xs={2}>
            <Input
              type="number"
              label={t('BOX_TO_PALLET_CONVERSION_RATE')}
              defaultValue={tariff.box_to_pallet_conversion_rate}
              ref="conversationRateInput"
              onChange={this.handleConversationRateChange()}
            />
            <Input
              type="number"
              label={t('FSC').toUpperCase()}
              defaultValue={tariff.fsc}
              onChange={this.handleFSCConversion}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

TariffOtherPropsEditor.propTypes = {
  tariff: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withTranslation()(withLocaleContext(TariffOtherPropsEditor));
